import { ArrowLeftOutlined } from '@ant-design/icons';
import type { ToOptions } from '@tanstack/react-router';
import { Button } from 'antd';
import { useGoBack } from '../../lib/use-go-back';

type Props = {
  // Where to go when there's no in-app history to step back to (direct link / new tab).
  fallbackTo: ToOptions['to'];
};

export const BackButton = ({ fallbackTo }: Props) => {
  const goBack = useGoBack(fallbackTo);

  return (
    <div style={{ marginBottom: 20, animation: 'fade-in var(--dur-normal) var(--ease-out) both' }}>
      <Button icon={<ArrowLeftOutlined />} type="text" style={{ paddingLeft: 0 }} onClick={goBack}>
        Back
      </Button>
    </div>
  );
};
